import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_270: DocMigration = {
  maxSchemaVersion: "0.0.270",
  description: "Correct the settingsHandle id property for annotation templates",
  apply(json: any) {
    for (const settingsId in json.settings) {
      const setting = json.settings[settingsId];

      if (setting.type !== "ANNOTATION_CATALOG_SETTINGS") {
        continue;
      }

      if (!Object.keys(setting.annotationTemplates ?? {}).length) {
        continue;
      }

      for (const annotationTemplateId in setting.annotationTemplates) {
        const annotationTemplate = setting.annotationTemplates[annotationTemplateId];
        const { settingsHandle } = annotationTemplate.handle;

        annotationTemplate.handle.settingsHandle = {
          type: "SETTINGS",
          id: settingsHandle.settingsId,
        };

        for (const componentId in annotationTemplate.components) {
          const component = annotationTemplate.components[componentId];

          const { annotationTemplateHandle } = component.handle;
          const { settingsHandle } = annotationTemplateHandle;
          annotationTemplateHandle.settingsHandle = {
            type: "SETTINGS",
            id: settingsHandle.settingsId,
          };
        }
      }
    }

    return json;
  },
};

export default migration_0_0_270;
